import React, { useEffect } from 'react'
import { Route, BrowserRouter as Router, Routes, Navigate } from 'react-router-dom'
import { useAppContext } from '../Context/AppContext'
import { useMain } from '../Hook/Main';
import Auth from '../Pages/Auth';
import { UserRoute } from './map';
function Index() {
    const { user } = useAppContext();
    const { Request, setData } = useMain();
    useEffect(() => {
        Request({
            url: "/items",
            key: "items",

        })
        Request({
            url: "/get-data",
            key: "categoreis",
            callback: (response) => {
               
                if (response) {
                    localStorage.setItem('settings', JSON.stringify(response.settings));
                    localStorage.setItem('info', JSON.stringify(response.info));
                    setData('categoreis', response.categories, 'data', true);
                    setData('info', response.info, 'data', true);
                }

            }
        })
    }, [])

    return (
        <Router>
            <Routes>
                {UserRoute.map((route, i) => {
                    if (route.user) {
                        if (user) {
                            return <Route key={i} path={route.path} element={route.element} />;
                        } else {
                            return <Route key={i} path={route.path} element={<Navigate to="/Auth" />} />
                        }
                    }
                    return <Route key={i} path={route.path} element={route.element} />
                })}
                {!user && <Route path="/Auth" element={<Auth />} />}
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </Router>
    )
}

export default Index